<template>
    <div class="ml-3 mr-3 no-padding" >
        <go-back-bar></go-back-bar>
        <kt-row>
            <kt-col>
                <kt-table is_responsive dir="ltr" class="table table-hover table-bordered">
                    <thead>
                    <tr>
                        <th class="text-center date">Date</th>
                        <th class="text-center time">Time</th>
                        <th class="text-center ip">Ip</th>
                        <th class="text-center">Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-bind:key="index" v-for="(activityLog, index) in activitiesLogs">

                        <td :class="'text-center ' + getVariant(activityLog.description.type)">
                            {{activityLog.date}}
                        </td>

                        <td :class="'text-center ' + getVariant(activityLog.description.type)">
                            {{activityLog.time}}
                        </td>

                        <td v-if="activityLog.description.loggedInUser"
                            :class="'text-center ' + getVariant(activityLog.description.type)">
                            <span style="display:block;" class="mb-1">
                                {{activityLog.description.ip}}
                            </span>
                            <span style="direction: rtl">
                                {{activityLog.description.loggedInUser}} : {{ $t('label.loggedInUser') }}
                            </span>

                        </td>

                        <td v-else :class="'text-center ' + getVariant(activityLog.description.type)">
                            {{activityLog.description.ip}}
                        </td>

                        <td class="text-right created-log" v-if="activityLog.description.attributes">
                            <kt-form-label >
                                action_type:
                            </kt-form-label>
                            <span>
                                {{activityLog.description.description_type}} ||
                            </span>

                            <kt-form-label>
                                subject:
                            </kt-form-label>
                            <span >
                                 {{activityLog.description.subject_type}} ||
                            </span>

                            <br>
                            <kt-form-label>
                                attributes:
                            </kt-form-label>
                            <span >
                                {{activityLog.description.attributes}}
                            </span>
                        </td>
                        <td class="text-right updated-log" v-else-if="activityLog.description.changes" >
                            <kt-form-label>
                                action_type:
                            </kt-form-label>
                            <span >
                                {{activityLog.description.description_type}} ||
                            </span>

                            <kt-form-label>
                                subject:
                            </kt-form-label>
                            <span >
                                 {{activityLog.description.subject_type}} ||
                            </span>

                            <kt-form-label>
                                changes:
                            </kt-form-label>
                            <br>
                            <kt-form-label>
                                new:
                            </kt-form-label>
                            <span >
                                 {{activityLog.description.changes.new}}
                            </span>
                            <br>
                            <kt-form-label>
                                old:
                            </kt-form-label>
                            <span >
                                 {{activityLog.description.changes.old}}
                            </span>
                        </td>
                        <td class="text-right updated-log" v-else-if="activityLog.description.event" >
                            <kt-form-label>
                                action_type:
                            </kt-form-label>
                            <span>
                                {{activityLog.description.event}}
                            </span>
                        </td>
                        <td class="text-right viewed-log" v-else>
                            <kt-form-label>
                                url:
                            </kt-form-label>
                            {{activityLog.description.url}}
                        </td>
                    </tr>
                    </tbody>
                </kt-table>
            </kt-col>
        </kt-row>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import GoBackBar from "../../components/custom/go-back-bar";
export default {
    components: {GoBackBar},
    data() {
        return {
            hashid: this.$route.params.hashid,
        }
    },
    computed: {
        ...mapGetters('user', [
            'activitiesLogs'
        ])
    },
    mounted() {
        this.$store.dispatch('user/fetchActivitiesLogs', this.hashid)

    },
    methods: {
        getVariant(type) {
            if (type == 'create')
                return 'created-log';
            else if (type == 'update')
                return 'updated-log';
            else if (type == 'view')
                return 'viewed-log';
            else
                return 'badge-danger';
        },
    }
}


</script>

<style >
    .table-hover tbody tr:hover td {
        background: #a7abc3;
    }
    @media screen and (min-width:300px){
        .time, .date, .ip{
            width: 30%;
        }
    }
    @media screen and (min-width:400px){
        .time, .date, .ip{
            width: 24% ;
        }
    }
    @media screen and (min-width:768px){
        .time, .date, .ip{
            width: 15% ;
        }
    }
    @media screen and (min-width:900px){
        .time, .date, .ip{
            width: 10%;
        }
    }

    .created-log {
        background-color: #62fb6b;
    }
    .updated-log {
        background-color: #ffec37
    }
    .viewed-log {
        background-color: #23c7d6ad
    }
    .table{
        table-layout: fixed;
    }
    td{
        word-wrap:break-word
    }
</style>